import { format, formatDistanceToNow, isValid } from "date-fns";
import { UncontrolledTooltip } from "reactstrap";

export const toDateFromTimestamp = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const raw = typeof value === "object" ? value.timestamp ?? value.date : value;
    const numeric = Number(raw);

    if (!Number.isFinite(numeric) || numeric <= 0) {
        const parsed = new Date(raw);
        return isValid(parsed) ? parsed : null;
    }

    // Unix seconds vs milliseconds
    const date = new Date(numeric < 1e12 ? numeric * 1000 : numeric);
    return isValid(date) ? date : null;
};

export const formatFindingDate = (date) => {
    if (!date) {
        return null;
    }

    return {
        absolute: format(date, "dd/MM/yyyy HH:mm"),
        relative: formatDistanceToNow(date, { addSuffix: true }),
    };
};

const FindingDateMeta = ({ id, icon, label, date, t, showLabel = true, variant = "list" }) => {
    if (!date) {
        return null;
    }

    const tooltipId = `finding-date-${id}`;
    const { absolute, relative } = formatFindingDate(date);

    if (variant === "detail") {
        return (
            <p className={`finding-date-detail ${showLabel ? "mb-1" : "mb-0"}`} id={tooltipId}>
                {showLabel ? (
                    <>
                        <strong>{t(label)}:</strong>{" "}
                    </>
                ) : null}
                <span>{absolute}</span>
                <UncontrolledTooltip placement="top" target={tooltipId} trigger="hover">
                    {relative}
                </UncontrolledTooltip>
            </p>
        );
    }

    return (
        <div className="finding-date-meta" id={tooltipId}>
            {icon ? (
                <i className={`${icon} finding-date-meta__icon`} aria-hidden="true" />
            ) : null}
            {showLabel ? (
                <span className="finding-date-meta__label">{t(label)}</span>
            ) : null}
            <span className="finding-date-meta__value">{absolute}</span>
            <UncontrolledTooltip placement="top" target={tooltipId} trigger="hover">
                {relative}
            </UncontrolledTooltip>
        </div>
    );
};

export { FindingDateMeta };

const FindingDates = ({ finding, t, className = "", variant = "list" }) => {
    if (finding?.is_bafa || (!finding?.release_date && !finding?.created_at)) {
        return null;
    }

    return (
        <div className={`finding-dates finding-dates--${variant} ${className}`.trim()}>
            <FindingDateMeta
                id={`${variant}-release-${finding.id}`}
                icon="ri-calendar-event-line"
                label="Published Date"
                date={toDateFromTimestamp(finding.release_date)}
                t={t}
                variant={variant}
            />
            <FindingDateMeta
                id={`${variant}-created-${finding.id}`}
                icon="ri-time-line"
                label="Created At"
                date={toDateFromTimestamp(finding.created_at)}
                t={t}
                variant={variant}
            />
        </div>
    );
};

export default FindingDates;
